import { ModuleRoute } from 'module-routes';

export enum InventoryPath {
  Supplier = 'supplier',
  Laboratory = 'laboratory',
  Category = 'category',
  FormatPresentation = 'format',
  UnitPresentation = 'unit',
  Product = 'product',
  ProductList = 'product-list',
  Lots = 'lot',
  Customer = 'customer',
  Services = 'services',
}

export const InventoryModuleRoutes = new Map<InventoryPath, <T>(id?: T) => string>([
  [InventoryPath.Supplier, () => `${ModuleRoute.Inventory}/${InventoryPath.Supplier}`],
  [InventoryPath.Laboratory, () => `${ModuleRoute.Inventory}/${InventoryPath.Laboratory}`],
  [InventoryPath.Category, () => `${ModuleRoute.Inventory}/${InventoryPath.Category}`],
  [InventoryPath.Product, () => `${ModuleRoute.Inventory}/${InventoryPath.Product}`],
  [InventoryPath.ProductList, () => `${ModuleRoute.Inventory}/${InventoryPath.ProductList}`],
  [InventoryPath.Lots, () => `${ModuleRoute.Inventory}/${InventoryPath.Lots}`],
  [InventoryPath.Customer, (id) => `${ModuleRoute.Inventory}/${id}/${InventoryPath.Customer}`],
  [InventoryPath.Services, () => `${ModuleRoute.Inventory}/${InventoryPath.Services}`],
  [InventoryPath.FormatPresentation, () => `${ModuleRoute.Inventory}/${InventoryPath.FormatPresentation}`],
  [InventoryPath.UnitPresentation, () => `${ModuleRoute.Inventory}/${InventoryPath.UnitPresentation}`],
]);

export const getInventoryModuleRoutes = <T>(route: InventoryPath, id?: T): string => {
  const routeFunction = InventoryModuleRoutes.get(route);
  if (routeFunction) {
    return routeFunction(id);
  }
  throw new Error(`Route ${route} not found}`);
};
